import React, {
  Component
}                     from 'react';
import PropTypes      from 'prop-types';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Modal,
  ButtonGroup,
  DropdownButton,
  MenuItem,
  Table
}                     from 'react-bootstrap';
import { withRouter } from 'react-router';
import { connect }    from 'react-redux';
import {
  bindActionCreators,
  compose
}                     from 'redux';
//import Alert          from '../../../components/alert/Alert';
import { createBrowserHistory } from 'history';
import {
  NewBreadcrumb as BreadcrumbComponent
}                        from '../../../components';

// include action file for add merchant
import '../../../style/subAdmin/SubAdmin.scss';
import { Notification } from '../../../components/notifications';
import isEmpty from 'lodash.isempty';
import { getFooterTemplate, saveHeaderTemplate} from '../../../redux/actions/pageTemplateAction';
import {renderAlert, clearAlert} from '../../../redux/actions/alertsActions';
import moment from 'moment';
import loader from '../../../style/loader/loader.scss'; 
import '../../../style/react-datetimepicker.scss';

import ReactHtmlParser from 'react-html-parser';
import Dialog from 'react-bootstrap-dialog';
import CKEditor from "react-ckeditor-component";
import Cookies from 'universal-cookie';
const cookies = new Cookies();
 
const history = createBrowserHistory();

const HorizontalLine = ({ }) => (
    <hr/>
);

const propTypes = {
    emailOverview: PropTypes.func.isRequired,
};
let cityItems=[];let isLoading="false",  csvData = [];

class HeaderTemplate extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props){

    super(props);
    this.state={
      path: ['Home', 'Header Template'], 
      links: ["home",'header-template'],
      list: [],
      header_content: '',
      french_header_content: '',
      dynamic_header_status: 'disable',
      alert: false,
      alertMessage: "",
      submitValue: 'Save',
      disabled: false,
    }

    this.content = this.content.bind(this);
    this.frenchContent = this.frenchContent.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
  }

  handleDismiss() {
    this.setState({ alert: false });
  }

  content(evt) {
    this.setState({
      header_content: evt.editor.getData()
    });
  }

  frenchContent(evt) {
    this.setState({
      french_header_content: evt.editor.getData()
    });
  }

  handleChange = (e) => {
    this.setState({[e.target.name] : e.target.value})
  }

  handlePageChange = () => {
    this.props.getFooterTemplate();
  }

  componentWillMount(){
    isLoading="true";
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData && siteData.dynamic_footer === 0){
      this.context.router.history.push("/restrictedAccess");
    }
    this.handlePageChange();
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({
      submitValue: 'Saving....',
      disabled: true,
    });
    let postData = {
      dynamic_header_status: this.state.dynamic_header_status,
      header_content: this.state.header_content,
      french_header_content: this.state.french_header_content,
    }
    this.props.saveHeaderTemplate(postData);
  }

  handleAlertShow() {
    this.setState({ alert: true });
  }

  componentWillReceiveProps(nextProps){
  	if(this.props.templateData !== nextProps.templateData){ 
  		if(nextProps.templateData){
  			isLoading="false";
  			this.setState({
          dynamic_header_status: nextProps.templateData.data.dynamic_header_status, 
          header_content: nextProps.templateData.data.header_content,
          french_header_content: nextProps.templateData.data.french_header_content,
        })
  		}
  	}

    if (this.props.updateStatus !== nextProps.updateStatus) {
      if (nextProps.updateStatus) {
        this.setState({
          submitValue: 'Save',
          disabled: false,
        });
        this.setState({ alert: false });
        this.handleAlertShow();
        this.props.renderAlert("success", nextProps.updateStatus.message);
        window.scrollTo(0, 0);
      }
    }

    if (this.props.error !== nextProps.error && !isEmpty(nextProps.error)) {
      this.setState({ alert: false });
      this.handleAlertShow();
      this.props.renderAlert("warning", nextProps.error);
      window.scrollTo(0, 0);
    }


    if (nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  editSource = (mode) => {
    const editor = mode.editor;
    if (editor.mode === 'source') {
      const editable = editor._.editable;
      editable.attachListener(editable, 'input', e => {
        this.content(mode)
      });
    }
  }

  frenchEditSource  = (mode) => {
    const editor = mode.editor;
    if (editor.mode === 'source') {
      const editable = editor._.editable;
      editable.attachListener(editable, 'input', e => {
        this.frenchContent(mode)
      });
    }
  }

  render() {    
    return (
      <div className="col-lg-12 add-sub-admin">
        <Dialog ref={(el) => { this.dialog = el }} />
        {(isLoading =='true') ? 
          <div className="loader">
            <p className="loading-message">
            <i>
                Loading...
            </i>
            </p>
            <div className="spinner">
                <div className="dot1"></div>
                <div className="dot2"></div>
            </div>
          </div> : ''
        }
       
        <div className="row">
          <div className="col-xs-12">
             <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
          </div>
        </div>
        <div className="panel">
          	<header className="panel-heading">Header Template</header>
  	        <div className="panel">
  	          {this.state.alert && this.state.alertMessage !=='' &&        
  	            <div className="col-lg-12">
  	              <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
  		              <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
  		            </Alert>
  	            </div>
  	          }
	          	<div className="panel-body">
  		          <form onSubmit={this.handleSubmit}>
                  <FormGroup controlId="footerForm">
                    <ControlLabel>Header Status</ControlLabel>
                    <FormControl componentClass="select" onChange={this.handleChange} name="dynamic_header_status" value={this.state.dynamic_header_status} placeholder="select">
                      <option value="enable">Enable</option>
                      <option value="disable">Disable</option>
                    </FormControl>
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>HTML Content:</ControlLabel>
                    <CKEditor
                      activeClass="p10"
                      name="contentdata"
                      content={this.state.header_content}
                      events={{
                        change: this.content,
                        blur: this.content,
                        afterPaste: this.content,
                        mode: this.editSource
                      }}
                      config={{allowedContent: true}}
                    />                    
                  </FormGroup>

                  <FormGroup>
                    <ControlLabel>HTML Content (Canadian French):</ControlLabel>
                    <CKEditor
                      activeClass="p10"
                      name="contentdata"
                      content={this.state.french_header_content}
                      events={{
                        change: this.frenchContent,
                        blur: this.frenchContent,
                        afterPaste: this.frenchContent,
                        mode: this.frenchEditSource
                      }}
                      config={{allowedContent: true}}
                    />                    
                  </FormGroup>
                  <Row className="BtnRow">
                    <Col md={12} xs={12}>
                      <Button
                        bsStyle="info"
                        type="submit"
                        id="saveButton"
                        disabled={this.state.disabled}
                      >
                        {this.state.submitValue}
                      </Button>
                      <Button
                        bsStyle="default"
                        onClick={() => this.context.router.history.push(`/page-template`)}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </form>
                <Row>
                    <Col md={12} xs={12}>
                      <Table striped bordered condensed hover>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Short Code</th>
                            <th>Detail</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>01</td>
                            <td>${'{cart}'}</td>
                            <td>Cart</td>
                          </tr>
                          <tr>
                            <td>02</td>
                            <td>${'{logout}'}</td>
                            <td>Logout/Login</td>
                          </tr>
                          <tr>
                            <td>03</td>
                            <td>${'{where_my_order}'}</td>
                            <td>Where's My Order?</td>
                          </tr>
                          <tr>
                            <td>04</td>
                            <td>${'{my_account}'}</td>
                            <td>My Account/Register</td>
                          </tr>
                          <tr>
                            <td>05</td>
                            <td>${'{language}'}</td>
                            <td>Language (Englist/French)</td>
                          </tr>
                          <tr>
                            <td>06</td>
                            <td>${'{search}'}</td>
                            <td>Search Box</td>
                          </tr>
                          <tr>
                            <td>07</td>
                            <td>${'{location}'}</td>
                            <td>Location Drop Down</td>
                          </tr>
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
	        	  </div>
  	        </div>
	    </div>
	  </div>
    );
  }
}
 
 

const mapStateToProps = (state,ownProps) => {
    return {
    	templateData: state.pageTemplateReducer.templateData,
      updateStatus: state.pageTemplateReducer.updateStatus,
      error: state.pageTemplateReducer.error,
      alertType: state.alertsReducer.alertType,
      message: state.alertsReducer.message
    };
};

export default compose(
  withRouter, 
  connect(mapStateToProps, {getFooterTemplate, saveHeaderTemplate, renderAlert, clearAlert})
)(HeaderTemplate);



// WEBPACK FOOTER //
// ./src/app/views/admin/pageTemplate/HeaderTemplate.js